export default __webpack_public_path__ + "static/media/right.367c6757.png";